// extracted by mini-css-extract-plugin
export var activeDot = "_9y-c";
export var buttonContainer = "_9y-9";
export var channelButton = "_9y-a";
export var clickable = "_9y-d";
export var content = "_9y-0";
export var contentFull = "_9y-2";
export var contentThird = "_9y-1";
export var contentWrapper = "_9y-7";
export var description = "_9y-5";
export var heightShort = "_9y-f";
export var image = "_9y-3";
export var imageContainer = "_9y-4";
export var selectButton = "_9y-e";
export var spinnerContainer = "_9y-b";
export var titleContent = "_9y-8";
export var titleWrapper = "_9y-6";